"use client"

import { useState } from "react"
import { useTranslations } from "@/lib/intl/use-translations"

interface Props {
  onSelect: (yes: boolean) => void
  isFocus?: boolean
}

export function InterestStep({ onSelect, isFocus = false }: Props) {
  const t = useTranslations("quiz")
  const [picked, setPicked] = useState<boolean | null>(null)
  // Freeze buttons only during the brief auto-advance animation so a
  // user returning from a later step can still re-pick.
  const [isAdvancing, setIsAdvancing] = useState(false)

  const handleClick = (yes: boolean) => {
    if (isAdvancing) return
    setPicked(yes)
    setIsAdvancing(true)
    window.setTimeout(() => onSelect(yes), 220)
  }

  return (
    <div
      className={
        "flex flex-col gap-3 sm:flex-row" +
        (isFocus ? " sm:justify-center" : "")
      }
    >
      <button
        onClick={() => handleClick(true)}
        disabled={isAdvancing && picked !== true}
        className={
          "type-title-md cursor-pointer rounded-[12px] border px-6 py-4 transition-colors disabled:cursor-not-allowed sm:min-w-[140px] " +
          (picked === true
            ? "border-deep-blue-900 bg-deep-blue-900 text-white"
            : "hover:border-deep-blue-900 hover:bg-deep-blue-50 border-neutral-300 bg-white text-neutral-900 disabled:opacity-40")
        }
      >
        {t("yes")}
      </button>
      <button
        onClick={() => handleClick(false)}
        disabled={isAdvancing && picked !== false}
        className={
          "type-title-md cursor-pointer rounded-[12px] border px-6 py-4 transition-colors disabled:cursor-not-allowed sm:min-w-[140px] " +
          (picked === false
            ? "border-neutral-500 bg-neutral-700 text-white"
            : "border-neutral-300 bg-white text-neutral-700 hover:border-neutral-500 hover:bg-neutral-50 disabled:opacity-40")
        }
      >
        {t("no")}
      </button>
    </div>
  )
}
